export type EntityFieldType = "string" | "number" | "date" | "money";

export type EntityFieldDef = {
  name: string;
  label: string;
  crudAlias: string;
  type?: EntityFieldType;
  required?: boolean;
  defaultValue?: string;
  displayOrder: number;
};

export type EntityDef = {
  name: string;
  label: string;
  fields: EntityFieldDef[];
};

const ENTITY_ORDER: string[] = ["Payment", "Claim", "Patient", "Procedure"];

export function buildEntitySchema(
  fieldDefinitions: StudioFieldDefinitionsMessage,
): EntityDef[] {
  return ENTITY_ORDER.filter(
    (name) => fieldDefinitions[name] && fieldDefinitions[name].length > 0,
  ).map((name) => ({
    name,
    label: name,
    fields: fieldDefinitions[name].map((f) => ({
      name: f.wieldyFieldName,
      label: f.wieldyFieldName,
      crudAlias: f.crudAlias,
      type: f.dataType as EntityFieldType,
      required: f.isRequired,
      defaultValue: f.defaultValue ?? undefined,
      displayOrder: f.displayOrder,
    })),
  }));
}
